"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ZonesModel = /** @class */ (function () {
    function ZonesModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/zones",
            UPDATE: APPURL + "/api/v1/zones",
            CREATE: APPURL + "/api/v1/zones",
        };
        this.zones = [];
        this.APPURL = APPURL;
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    ZonesModel.prototype.extract = function (result) {
        return result.data;
    };
    ZonesModel.prototype.cacheResults = function (result) {
        this.zones = this.extract(result);
        return this.zones;
    };
    ZonesModel.prototype.getZones = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    ZonesModel.prototype.createZone = function (zone) {
        return this.$http
            .post(this.URLS.CREATE, zone)
            .then(this.cacheResults);
    };
    ZonesModel.prototype.edit = function (zone) {
        return this.$http
            .post(this.URLS.FETCH + "/" + zone.id, zone)
            .then(this.cacheResults);
    };
    ZonesModel.prototype.editFallbackLocation = function (zone) {
        var data = {
            location: {
                name: zone.fallback_pickup_location.name,
                address: zone.fallback_pickup_location.address,
            },
        };
        return this.$http
            .put(this.URLS.FETCH + "/" + zone.id + "/fallback-location", data)
            .then(this.cacheResults);
    };
    ZonesModel.prototype.editColors = function (zone) {
        var _a, _b;
        var data = {
            bg_color: (_a = zone.bg_color) !== null && _a !== void 0 ? _a : null,
            text_color: (_b = zone.text_color) !== null && _b !== void 0 ? _b : null,
        };
        return this.$http
            .put(this.URLS.FETCH + "/" + zone.id + "/colors", data)
            .then(this.cacheResults);
    };
    ZonesModel.prototype.deleteZone = function (id) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    ZonesModel.prototype.deleteSector = function (zone_id, sector_id) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + zone_id + "/sectors/" + sector_id)
            .then(this.cacheResults);
    };
    ZonesModel.prototype.addZipCode = function (zone_id, data) {
        return this.$http
            .post(this.URLS.FETCH + "/" + zone_id + "/sectors", data)
            .then(this.cacheResults);
    };
    /**
     * Calculate total area of a zone from its zoneparts
     * Returns area in square meters
     */
    ZonesModel.prototype.calculateZoneArea = function (zoneparts) {
        // This would use a geometry library like turf.js
        // For now, return 0 as placeholder
        return 0;
    };
    /**
     * Merge zoneparts geometries into a single zone geometry
     */
    ZonesModel.prototype.mergeZonepartsGeometry = function (zoneparts) {
        var validGeometries = zoneparts
            .filter(function (zp) { return zp.geometry; })
            .map(function (zp) { return zp.geometry; });
        if (validGeometries.length === 0) {
            return null;
        }
        if (validGeometries.length === 1) {
            return validGeometries[0];
        }
        // This would use turf.js union operation
        // For now, return a MultiPolygon placeholder
        return {
            type: "MultiPolygon",
            coordinates: [],
        };
    };
    return ZonesModel;
}());
ZonesModel.$inject = ["$http", "APPURL"];
exports.default = ZonesModel;
